<template>
  <div class="order-add-product">
    <div class="card">
      <div class="card-body container">
        <div class="details">
          <div>
            <strong>{{product.DESCRIPCION}}</strong>
          </div>
          <div>
            <span class="text-muted">1ud x {{productPvp}}€</span>
            ....
            <strong>TOTAL: {{productTotal}}€</strong>
          </div>
        </div>
        <button class="btn btn-info" @click="onAddProduct">
          <i class="fa fa-cart-plus" />
          AÑADIR
        </button>
      </div>
    </div>

    <div class="alert alert-danger mt-4" v-if="errors && errors.length > 0">
      <li v-for="(error, i) in errors" :key="i">
        <small>{{error}}</small>
      </li>
    </div>

    <AppSection title="SELECCIONAR FORMATO" v-if="hasFormats">
      <ProductFormats
        :formats="productFormats"
        :selected="this.format"
        @formatSelected="onFormatSelected"
      />
    </AppSection>
    <AppSection :title="extrasTitle" v-if="hasExtras" padding="0">
      <ul class="extras-tabs" v-if="hasExtras && modificadores.length > 1">
        <li
          class="extra-tab"
          :class="getTabClass(extra)"
          :key="extra.CODMODIFICADOR"
          v-for="extra in productExtras"
          @click="selectedExtra = extra"
        >{{extra.DESCRIPCION}}</li>
      </ul>
      <template v-for="extra in productExtras">
        <ProductExtras
          :key="extra.CODMODIFICADOR"
          :extras="{extra}"
          v-show="extra.CODMODIFICADOR === selectedExtra.CODMODIFICADOR"
          @optionSelected="onOptionSelected"
          @optionDeleted="onOptionDeleted"
        />
      </template>
    </AppSection>
  </div>
</template>

<script>
import NumProductsPanel from "./NumProductsPanel";
import ProductFormats from "../Products/ProductFormats";
import ProductExtras from "../Products/ProductExtras";
import ProductExtrasSelector from "./ProductExtrasSelector";

export default {
  components: {
    ProductExtrasSelector,
    NumProductsPanel,
    ProductFormats,
    ProductExtras
  },
  props: {
    uds: { type: Number, default: 1 },
    product: { type: Object, required: true },
    formats: { type: Array },
    modificadores: { type: Array }
  },
  data() {
    return {
      selectedExtra: {},
      format: {},
      extras: [],
      errors: []
    };
  },
  mounted() {
    if (this.hasExtras && this.modificadores.length > 0) {
      this.selectedExtra = this.modificadores[0];
    }
  },
  computed: {
    productPvp() {
      let pvp = Number(this.product.PVP);
      if (this.format && this.format.PVP && Number(this.format.PVP || 0) > 0)
        pvp = Number(this.format.PVP || 0);
      return pvp.toFixed(2);
    },
    productTotal() {
      let total = Number(this.product.PVP);
      if (this.format && this.format.PVP && Number(this.format.PVP || 0) > 0)
        total = Number(this.format.PVP || 0);
      const extras = this.extras;
      if (extras && extras.length > 0) {
        extras.forEach(e => {
          e.extras.forEach(o => (total += Number(o.INCPRECIO || 0)));
        });
      }
      return total.toFixed(2);
    },
    hasFormats() {
      return this.formats && this.formats.length > 0;
    },
    hasExtras() {
      return this.modificadores && this.modificadores.length > 0;
    },
    extrasTitle() {
      return this.product.ESMENU ? "PLATOS DEL MENU" : "EXTRAS";
    },
    productFormats() {
      return this.formats || [];
    },
    productExtras() {
      return this.modificadores || [];
    }
  },
  methods: {
    getTabClass(extra) {
      return extra.CODMODIFICADOR === this.selectedExtra.CODMODIFICADOR
        ? "active"
        : "";
    },
    onAddProduct() {
      const product = this.product;
      const format = this.format;
      const extras = this.extras || [];

      this.errors = [];
      let errors = [];

      if (this.formats && this.formats.length > 0 && !format) {
        alert("DEBE SELECCIONAR UN FORMATO PARA EL PRODUCTO");
        return false;
      }
      if (this.modificadores && this.modificadores.length > 0) {
        this.modificadores.forEach(mod => {
          let min = mod.MINIMO;
          if (mod.ESMENU) min = 1;
          if (min > 0) {
            let cuantos = 0;
            extras.forEach(e => {
              e.extras.forEach(() => {
                if (e.extra.CODMODIFICADOR === mod.CODMODIFICADOR) cuantos++;
              });
            });
            if (cuantos < min) {
              if (mod.ESMENU)
                errors.push(`SELECCIONA ${mod.DESCRIPCION} PARA CONTINUAR`);
              else
                errors.push(
                  `SELECCIONAR ${min} DEL EXTRA ${mod.DESCRIPCION} COMO MÍNIMO`
                );
            }
          } else console.info("salimos en (min > 0)");
        });
      } else console.info("salimos en (min > 0)");

      if (errors.length > 0) {
        errors.forEach(error => this.errors.push(error));
        return false;
      }
      this.$emit("addProduct", {
        ...product,
        UDS: 1,
        FORMAT: format,
        EXTRAS: extras,
        TOTAL: Number(this.productTotal)
      });
    },
    onOptionSelected(extras) {
      this.extras = this.extras.filter(
        e => e.extra.CODMODIFICADOR !== extras.extra.CODMODIFICADOR
      );
      if (extras && extras.extras && extras.extras.length > 0) {
        this.extras.push(extras);
      }
    },
    onOptionDeleted(extras) {
      this.extras = this.extras.filter(
        e => e.extra.CODMODIFICADOR !== extras.extra.CODMODIFICADOR
      );
    },
    onFormatSelected(format) {
      this.format = format;
    }
  }
};
</script>

<style lang="scss">
.order-add-product {
  display: flex;
  flex-direction: column;

  .container {
    display: flex;
  }

  .details {
    flex: 1;
  }

  .extras-tabs {
    background-color: #e5e5e5;
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0 0 1rem 0;
    font-weight: bold;
    height: 50px;

    .extra-tab {
      align-items: center;
      border-bottom: 0.2em solid transparent;
      display: flex;
      font-size: 14px;
      flex: 1;
      text-align: center;
      justify-content: center;
      padding: 0.4rem 0.8rem;

      &.active {
        background-color: #fff;
        border-bottom: 0.2em solid #18a2b8;
      }
    }
  }

  .extras__popup {
    background-color: rgba(0, 0, 0, 0.42);
    bottom: 0;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000000;

    &__content {
      background-color: #f2f2f2;
      border-radius: 0.2rem;
      padding: 0.4rem;
      position: absolute;
      top: 0.42rem;
      bottom: 0.42rem;
      left: 0.42rem;
      right: 0.42rem;
      overflow-y: scroll;
    }
  }
}
</style>